export class DeudaAdicionalPendienteItem {
	public folio: number;
	public facturaId?: string;
	public transbankId?: string;
	public planUsuarioId: string;
	public referencia: string;
	public tipo: string;
	public total: number;
	public fechaEmision: Date;
	public fechaPago?: Date;
	public pagada: boolean;
	public vencida: boolean;
}

export class DeudaAdicionalPendiente {
	public emisorId: string;
	public tieneDeuda: boolean;
	public cantidadFacturas: number;
	public totalPendiente: number;
	public puedeRegularizarEnApp: boolean;
	public mensaje: string;
	public facturas: DeudaAdicionalPendienteItem[] = [];
}
